export default __webpack_public_path__ + "static/ppc-review-1-8dd86c321212be77ca66c519c484c21c.png";